import { saveAs } from 'file-saver';
import { loadExcelJS } from './spreadsheetLibraries';
import { removeSpecialCharsOfData } from './securityCheck';

const smartExportExcel = async ({ baseData, name, title, detailedTable, showTitle = true }) => {
  const workSheetName = (name || '').replace(/[*?:/\\[\]]/g, '');

  const Excel = await loadExcelJS();
  const workbook = new Excel.Workbook();
  const worksheet = workbook.addWorksheet(workSheetName, { title: 'tet' });

  /* Security check */
  const data = removeSpecialCharsOfData(baseData);

  if (showTitle) {
    worksheet.getRow(1).values = [title ?? workSheetName];
    worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('A1').font = { size: 18 };
    worksheet.mergeCells(1, 1, 1, Object.keys(data[0]).length);
  }

  if (detailedTable) {
    worksheet.addTable({
      name: 'MyDetailedTable',
      ref: showTitle ? 'A2' : 'A1',
      headerRow: true,
      style: {
        theme: null
      },
      columns: Object.keys(detailedTable[0]).map((column) => ({ name: column })),
      rows: detailedTable.map((item) => Object.values(item))
    });
  }

  worksheet.addTable({
    name: 'MyTable',
    ref: detailedTable ? 'A5' : showTitle ? 'A2' : 'A1',
    headerRow: true,
    style: {
      theme: null
    },
    columns: Object.keys(data[0]).map((column) => ({ name: column })),
    rows: data.map((item) => Object.values(item))
  });

  workbook.xlsx.writeBuffer().then((bufferData) => {
    const blob = new Blob([bufferData], { type: 'application/octet-stream' });
    saveAs(blob, `${workSheetName}.xlsx`);
  });
};

export default smartExportExcel;
